import React from 'react'
import {GridColDef} from '@mui/x-data-grid'
import {Box, Button, Chip} from '@mui/material'
import {AdministratorHistory} from '../../redux/modules/administratorHistory'
import {BulkUploadBatchListItem} from '../../redux/modules/bulkUploadBatches'

export type AllEventsRow =
  | ({isBulkSummary: false} & AdministratorHistory)
  | {isBulkSummary: true; id: string; batch: BulkUploadBatchListItem}

export const ACTION_TYPE_LABELS: Record<number, string> = {
  1: 'Create Patient',
  2: 'Assign Serial Number',
  3: 'Remove Serial Number',
  4: 'Reset Patient Data',
  5: 'Delete User',
  6: 'Update Patient',
}

export const rowDate = (row: AllEventsRow): string =>
  row.isBulkSummary ? String(row.batch.createdAt) : String(row.date)

export const createAllEventsColumns = (
  onClickViewDetails: (batchId: string) => void,
): GridColDef[] => [
  {
    field: 'id',
    headerName: 'ID',
    flex: 2,
  },
  {
    field: 'userEmail',
    headerName: 'User Email',
    flex: 2,
    valueGetter: params => {
      const row = params.row as AllEventsRow
      return row.isBulkSummary ? row.batch.user?.email ?? '--' : row.user?.email ?? '--'
    },
  },
  {
    field: 'actionType',
    headerName: 'Action Type',
    flex: 3,
    renderCell: params => {
      const row = params.row as AllEventsRow
      if (row.isBulkSummary) {
        return (
          <Box sx={{display: 'flex', alignItems: 'center', gap: 1}}>
            <Chip label="Bulk Upload" size="small" />
            <Button size="small" onClick={() => onClickViewDetails(row.batch.id)}>
              View details
            </Button>
          </Box>
        )
      }
      return ACTION_TYPE_LABELS[row.actionType] ?? row.actionType
    },
  },
  {
    field: 'patient',
    headerName: 'Patient',
    flex: 2,
    valueGetter: params => {
      const row = params.row as AllEventsRow
      if (row.isBulkSummary) {
        return `${row.batch.patientsCreated} created, ${row.batch.patientsUpdated} updated`
      }
      return row.patient ? `${row.patient.firstName} ${row.patient.lastName}` : '--'
    },
  },
  {
    field: 'deviceUdid',
    headerName: 'Device UDID',
    flex: 2,
    align: 'center',
    headerAlign: 'center',
    valueGetter: params => {
      const row = params.row as AllEventsRow
      if (row.isBulkSummary) {
        return `${row.batch.devicesAssigned} devices`
      }
      return row.device?.udid || '--'
    },
  },
  {
    field: 'date',
    headerName: 'Action Date',
    flex: 2,
    valueGetter: params => {
      const row = params.row as AllEventsRow
      return new Date(rowDate(row)).toISOString().split('T')[0]
    },
  },
]
